function _di(name, id) {
    return function(obj){
        var params = obj||{};
        //14225 活动通用 id
        params.id = id||14225;
        params.ts = Date.now();
        var url = 'util/statistical?point=' + JSON.stringify(params);
        // console.log('埋点链接：'+ url);
        console.log(name, params)
        iframeInsert(url);
        // console.log('埋点完毕');
    }
}

function iframeInsert(url) {
    var iframe = document.createElement('iframe');
    var URL = 'loopsmozat://' + url
    iframe.setAttribute('src', URL);
    iframe.style.height = 0;
    iframe.style.width = 0;
    iframe.style.position = 'absolute';
    iframe.style.zIndex = -1000;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    console.log('iframeInsert完毕=>%s', URL);
    // after 1000ms. remove the iframe to make it looks clean.
    setTimeout(function() {
        document.body.removeChild(iframe)
    }, 1000);
}


export {_di, iframeInsert}


// WEBPACK FOOTER //
// ./src/common/js/di.js